import {
  Big42Icon,
  CitelineIcon,
  ClarivateDRGIcon,
  DASenseIcon,
  Digital360Icon,
  EvaluateIcon,
  FirstWordReportsIcon,
  GlobalAccessIndexIcon,
  GlobalMarsIcon,
  RICIIcon,
  SimulateAIIcon,
  SomelierIcon,
  BracoIcon,
} from '@/storybook/icons';

const appLinkConfig = [
  {
    url: 'https://big42.roche.com/home',
    Icon: Big42Icon,
    name: 'BIG42',
    allowedCountries: ['DE'],
  },
  {
    url: 'https://bracoforyou.roche.com/Home/Inicio',
    Icon: BracoIcon,
    name: 'Braco',
    allowedCountries: ['ES'],
  },
  {
    url: 'https://www.citeline.com/en/resource-center/20230612/roche-platinum-resource-center',
    Icon: CitelineIcon,
    name: 'Citeline',
  },
  {
    url: 'https://authentication.decisionresourcesgroup.com/login/',
    Icon: ClarivateDRGIcon,
    name: 'Clarivate DRG',
  },
  {
    url: 'https://dasense.roche.com',
    name: 'DA Sense',
    Icon: DASenseIcon,
  },
  {
    url: 'https://sites.google.com/roche.com/digital360/home?authuser=0',
    Icon: Digital360Icon,
    name: 'Digital 360',
  },
  {
    url: 'https://app.evaluate.com/ux/WebReport/Welcome2.aspx',
    name: 'Evaluate',
    Icon: EvaluateIcon,
  },
  {
    url: 'https://www.firstwordreports.com/',
    name: 'FirstWord Reports',
    Icon: FirstWordReportsIcon,
  },
  {
    url: 'https://globalmars.roche.com/',
    name: 'GlobalMARS',
    Icon: GlobalMarsIcon,
  },
  {
    url: 'https://eu-west-1a.online.tableau.com/#/site/tabemeacloud/views/RocheAccessIndex/Homepage?:iid=1',
    Icon: GlobalAccessIndexIcon,
    name: 'Global Access Index',
  },
  {
    url: 'https://studio.roche.com',
    name: 'RICI',
    Icon: RICIIcon,
  },
  {
    url: 'https://vrt-roche-pilot.zsservices.com/dashboard',
    name: 'Simulate AI',
    Icon: SimulateAIIcon,
  },
  {
    url: 'https://somelier.ecas.roche.com/home/login',
    name: 'Somelier',
    Icon: SomelierIcon,
  },
];

export default appLinkConfig;
